// ads frontend — minimal Vite + vanilla TS SPA.
//
// Fetches /api/v1/ping from the backend (proxied to :8086 in dev, reverse-
// proxied by nginx in prod) and renders the app identity + current live config.
// Edit `greeting` in r-nacos to watch this refresh within seconds with no
// rebuild — that is the live-reload demo baked into the template.

interface PingResponse {
  app: {
    app?: { name?: string; version?: string };
    greeting?: string;
    feature_flags?: { example_flag?: boolean };
    limits?: { max_connections?: number };
  };
  config_from: "nacos" | "local";
}

const app = document.getElementById("app")!;

function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  opts: { class?: string; text?: string } = {},
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (opts.class) node.className = opts.class;
  if (opts.text !== undefined) node.textContent = opts.text;
  return node;
}

async function refresh(): Promise<void> {
  const card = el("div", { class: "card" });
  card.appendChild(el("h1", { text: "ads" }));
  card.appendChild(el("p", { class: "muted", text: "Rust project template · 前后端分离" }));

  try {
    const res = await fetch("/api/v1/ping", { cache: "no-store" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data: PingResponse = await res.json();

    card.appendChild(el("h2", { text: "App" }));
    const meta = el("dl");
    meta.appendChild(el("dt", { text: "name" }));
    meta.appendChild(el("dd", { text: data.app.app?.name ?? "-" }));
    meta.appendChild(el("dt", { text: "version" }));
    meta.appendChild(el("dd", { text: data.app.app?.version ?? "-" }));
    card.appendChild(meta);

    card.appendChild(el("h2", { text: "Config (live)" }));
    const cfg = el("dl");
    cfg.appendChild(el("dt", { text: "config_from" }));
    const badge = el("dd");
    const badge_span = el("span", {
      class: `badge ${data.config_from === "nacos" ? "badge-ok" : "badge-warn"}`,
      text: data.config_from,
    });
    badge.appendChild(badge_span);
    cfg.appendChild(badge);
    cfg.appendChild(el("dt", { text: "greeting" }));
    cfg.appendChild(el("dd", { text: data.app.greeting ?? "-" }));
    cfg.appendChild(el("dt", { text: "example_flag" }));
    cfg.appendChild(el("dd", { text: String(data.app.feature_flags?.example_flag ?? false) }));
    cfg.appendChild(el("dt", { text: "max_connections" }));
    cfg.appendChild(el("dd", { text: String(data.app.limits?.max_connections ?? 0) }));
    card.appendChild(cfg);
  } catch (e) {
    card.appendChild(
      el("p", { class: "error", text: `failed to reach /api/v1/ping: ${(e as Error).message}` }),
    );
  }

  app.replaceChildren(card);
}

// Initial render, then poll every 3s to demonstrate live-reload (nacos push).
void refresh();
setInterval(refresh, 3000);
